import { cn } from '../lib/cn'

/** El isotipo real de NovaBerry: el arco rojo del fruto abrazando las
 *  capas de campo verde, con las dos hojas. Es el archivo de marca, no
 *  una aproximación dibujada a mano. */
export function Isotipo({ className }: { className?: string }) {
  return (
    <img
      src="/logo-isotipo.png"
      alt="NovaBerry"
      className={cn('shrink-0 object-contain', className)}
    />
  )
}

/** Logo completo: isotipo + logotipo. El nombre usa el degradado del
 *  espectro NovaBerry, que es la firma visual de la marca. */
export function Logo({
  className,
  conBajada = false,
}: {
  className?: string
  conBajada?: boolean
}) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <Isotipo className="size-9" />
      <div className="min-w-0">
        <div className="font-display text-[19px] leading-none font-bold tracking-tight">
          <span className="text-bosque-500 dark:text-bosque-200">Nova</span>
          <span className="bg-gradient-to-r from-rojo-500 via-magenta-500 to-tinta-500 bg-clip-text text-transparent">
            Berry
          </span>
        </div>
        {conBajada && (
          <div className="mt-1 text-[9px] font-semibold tracking-[0.18em] texto-tenue uppercase">
            Naturalmente incomparable
          </div>
        )}
      </div>
    </div>
  )
}
